export default "__VITE_ASSET__ee1faeea__"